export enum MetaProperty {
  url = 'og:url',
  type = 'og:type',
  title = 'og:title',
  image = 'og:image',
  description = 'og:description',
}
